import { render } from "./ArrayProperties.vue?vue&type=template&id=0ae6b24a"
import script from "./ArrayProperties.vue?vue&type=script&lang=js"
export * from "./ArrayProperties.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__